import React from 'react';
import setColor from "../setColor/setColor";
import setIcon from "../setIcon/setIcon";
import {addSnackbar, closeSnackbar} from "../../../stores/notifications/notificationSlice";


export const notification = (type, text, content, typePersist) => async (
    dispatch,
    getState,
) => {
    dispatch(addSnackbar({
            message:
                <div className="notificationDetails">
                    <div
                        className="upDiv"
                        style={{backgroundColor: setColor(type)}}
                    />
                    <div
                        className="ContentNotification"
                    >
                        {content}
                        {/*<h3>{text}</h3>*/}
                        {setIcon(type)}
                    </div>
                </div>,
            options: {
                key: new Date().getTime() + Math.random(),
                variant: type,
                action: key => (
                    <i
                        className="fa fas fa-times info NotificationAction"
                        style={{color: setColor(type)}}
                        onClick={() => dispatch(closeSnackbar({dismissAll: !key,key}))}
                    />
                ),
                persist: typePersist ? typePersist : false
            },
        })
    );
};


